import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useLang } from "../contexts/LangContext";
import Logo from "../components/Logo";

export default function Login() {
  const { t } = useLang();
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      const to = location.state?.from || "/dashboard";
      navigate(to, { replace: true });
    } else {
      setErr(res.error);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 pt-20" data-testid="login-page">
      <div className="hidden lg:block relative">
        <img src="https://images.unsplash.com/photo-1503634192480-e77a6436f075?w=2000" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-navy/40" />
        <div className="absolute bottom-12 left-12 text-white max-w-md">
          <div className="label-eyebrow text-club-yellow mb-3">{t.auth.loginTitle}</div>
          <p className="font-serif text-3xl leading-tight">{t.auth.loginSub}</p>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-16">
        <form onSubmit={submit} className="w-full max-w-md space-y-6" data-testid="login-form">
          <Logo size="md" />
          <h1 className="font-serif text-4xl text-navy">{t.auth.loginTitle}</h1>
          <div className="divider-gold" />

          <div>
            <label className="text-xs uppercase tracking-widest text-slate-500 block mb-2">{t.auth.email}</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full border-b border-slate-300 focus:border-navy outline-none py-3 bg-transparent" data-testid="login-email" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-slate-500 block mb-2">{t.auth.password}</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full border-b border-slate-300 focus:border-navy outline-none py-3 bg-transparent" data-testid="login-password" />
          </div>

          {err && <div className="text-sm text-red-600" data-testid="login-error">{err}</div>}

          <button type="submit" disabled={loading} className="w-full bg-navy text-white py-4 text-xs uppercase tracking-[0.25em] hover:bg-club-red transition-colors disabled:opacity-60" data-testid="login-submit">
            {loading ? "..." : t.auth.submitLogin}
          </button>

          <div className="flex items-center justify-between text-sm pt-2">
            <Link to="/forgot-password" className="text-slate-500 hover:text-club-red" data-testid="link-forgot">
              {t.auth.forgot}
            </Link>
            <Link to="/register" className="text-navy underline decoration-club-yellow underline-offset-4 hover:text-club-red" data-testid="link-to-register">
              {t.auth.signUpHere}
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
